<template>
    <va-edit-layout>
        <FinancialEventGroup-form
            :id="id"
            :title="title"
            :item="item"
        ></FinancialEventGroup-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
